<template>
  <div class="otp_input">
    <!-- Hidden input field that captures all keyboard input -->
    <input ref="singleInput"
           type="text"
           :maxlength="length"
           pattern="[0-9]*"
           inputmode="numeric"
           v-model="otpCode"
           @input="onInput"
           @paste="onPaste"
           class="hidden_input"/>

    <!-- Visual display of digits as separate boxes -->
    <div class="digit_display">
      <div v-for="i in length" :key="i" class="digit_box" :class="{ 'active': activeIndex === i-1 }" @click="focusInput">
        <!-- Show digit or empty string if not entered -->
        {{ otpCode[i-1] || '' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "otpCodeInput",
  props: {
    length: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      // Holds the current OTP code as a string
      otpCode: "",
      // Tracks if the code was previously complete to prevent duplicate events
      wasComplete: false,
      // Tracks the currently active digit (for highlighting)
      activeIndex: 0
    };
  },
  watch: {
    // Update the active cursor position when OTP code changes
    otpCode(newVal) {
      this.activeIndex = Math.min(newVal.length, this.length - 1);
    }
  },
  mounted() {
    // Automatically focus the input when the component appears
    this.focusInput();
  },  
  methods: {
    // Handles input event: filters non-numeric characters and limits to max length
    onInput() {
      this.otpCode = this.otpCode.replace(/[^0-9]/g, "").slice(0, this.length);
      this.emitCode();
    },
    // Handles paste event: extracts digits from clipboard and fills OTP code
    onPaste(event) {
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/[^0-9]/g, '')
        .slice(0, this.length);
      
      this.otpCode = pasted;
      this.emitCode();
    },
    // Emits the current OTP code and triggers 'complete' event if all digits are entered
    emitCode() {
      // Check if all fields are filled (code length matches desired length)
      const isComplete = this.otpCode.length === this.length;
      // Emit the current value to the parent component via v-model
      this.$emit("input", this.otpCode);
      // Emit 'complete' event only when transitioning from incomplete to complete
      if (isComplete && !this.wasComplete) this.$emit("complete", this.otpCode);
      // Update the previous completion state
      this.wasComplete = isComplete;
    },    
    // Focuses the hidden input when clicking on any digit box
    focusInput() {
      this.$refs.singleInput.focus();
    }
  }
};
</script>